import React, { useContext, useEffect, useState } from 'react';
import { LanguageContext } from "../languages/LanguageContext";
import { Link, useLocation } from "react-router-dom";
import { IoIosArrowDown} from "react-icons/io";
import { RiMenu3Line } from "react-icons/ri";
import { IoCloseOutline } from "react-icons/io5";

const Header = () => {
    const { setLanguage, language, translations } = useContext(LanguageContext);
    const [ menu, setMenu ] = useState(false);
    const location = useLocation();
    const currentPage = location.pathname.substring(1);

    const [scrolled, setScrolled] = useState(false);

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            if (scrollTop > 280) {
                setScrolled(true);
            } else {
                setScrolled(false);
            }
        };

        // Stop scrolling of main body when mobile menu is open
        menu ? document.body.style.overflow = 'hidden' : document.body.style.overflow = 'auto';

        window.addEventListener('scroll', handleScroll);

        // Clean up the event listener when the component unmounts
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, [menu]);

    return (
        <div className={scrolled ? 'header-container scrolled max-w' : 'header-container max-w'}>
            <div className='logo-container pointer' onClick={() => window.location.href = '/'}>
                {/*<h1>A. Biedermann</h1>*/}
                {/*<span>BVÖ Bildungsberatung & Vermittlungsagentur GmbH</span>*/}
                {/*<img src='/icons/logo.png' alt='company-logo'/>*/}
                <div className='bvo'>
                    <div className='b'>B</div>
                    <div className='v'>V</div>
                    <div className='o'>Ö</div>
                </div>
                <img className='children' src='/icons/logo_children.png' alt=''/>
                <span className='company-name'>
                    BVÖ Bildungsberatung und <br /> Vermittlungsagentur GmbH
                </span>
            </div>
            <div className='flex gap-1 ai-c'>
                <div className='navigation flex'>
                    <Link
                        className={currentPage === "" ? 'selected' : ''}
                        to='/'
                    >{translations[language]["home"]}</Link>
                    <Link
                        className={currentPage === "news" ? 'selected' : ''}
                        to='/news'
                    >{translations[language]["news"]}</Link>
                    <Link
                        className={currentPage === "press" ? 'selected' : ''}
                        to='/press'
                    >{translations[language]["press"]}</Link>
                    <li className="dropdown-container">
                        <a
                            className={
                                currentPage === "work" ||
                                currentPage === "accommodation" ||
                                currentPage === "graduates" ||
                                currentPage === "friendbook" ||
                                currentPage === "videos" ||
                                currentPage === "archive" ? 'selected' : ''}
                            href='/'
                        >
                            Erasmus <IoIosArrowDown className='icon' />
                        </a>
                        <ul className="dropdown-menu">
                            <li>
                                <Link
                                    className={currentPage === "work" ? 'selected' : ''}
                                    to="/work"
                                >{translations[language]["internationalWork"]}</Link>
                            </li>
                            <li>
                                <Link
                                    className={currentPage === "accommodation" ? 'selected' : ''}
                                    to='/accommodation'
                                >{translations[language]["accommodation"]}</Link>
                            </li>
                            <li>
                                <Link
                                    className={currentPage === "graduates" ? 'selected' : ''}
                                    to='/graduates'
                                >{translations[language]["graduates"]}</Link>
                            </li>
                            <li>
                                <Link
                                    className={currentPage === "friendbook" ? 'selected' : ''}
                                    to='/friendbook'
                                >{translations[language]["friendbook"]}</Link>
                            </li>
                            <li>
                                <Link
                                    className={currentPage === "archive" ? 'selected' : ''}
                                    to="/archive"
                                >{translations[language]["archive"]}</Link>
                            </li>
                            <li>
                                <Link
                                    className={currentPage === "videos" ? 'selected' : ''}
                                    to="/videos"
                                >{translations[language]["videos"]}</Link>
                            </li>
                        </ul>
                    </li>
                    <Link
                        className={currentPage === "contact" ? 'selected' : ''}
                        to='/contact'
                    >{translations[language]["contact"]}</Link>
                    <Link
                        className={currentPage === "about" ? 'selected' : ''}
                        to='/about'
                    >{translations[language]["about"]}</Link>
                </div>
                <div className='language-container'>
                    <div className={language === 'en' ? 'flag-button active' : 'flag-button'} onClick={() => setLanguage('en')}><img src='/icons/flag_uk.webp' alt='english-flag' /></div>
                    <div className={language === 'de' ? 'flag-button active' : 'flag-button'} onClick={() => setLanguage('de')}><img src='/icons/flag_de.png' alt='german-flag' /></div>
                </div>
                <div className='mobile-menu-button flex ai-c' onClick={() => setMenu(true)}>
                    <RiMenu3Line className='menu-open-icon' />
                </div>
            </div>
            { menu &&
                <div className='mobile-container flex col'>
                    <div className='mobile-header flex w-full jc-sb ai-c'>
                        <span>{translations[language]["menu"]}</span>
                        <div className='flex gap-sm ai-c'>
                            <div className='mobile-language-container'>
                                <div className={language === 'en' ? 'flag-button active' : 'flag-button'} onClick={() => setLanguage('en')}><img src='/icons/flag_uk.webp' alt='english-flag' /></div>
                                <div className={language === 'de' ? 'flag-button active' : 'flag-button'} onClick={() => setLanguage('de')}><img src='/icons/flag_de.png' alt='german-flag' /></div>
                            </div>
                            <IoCloseOutline className='menu-close-icon' onClick={() => setMenu(false)}/>
                        </div>
                    </div>
                    <div className='mobile-navigation flex col gap-sm'>
                        <Link className={currentPage === "" ? 'selected' : ''} to='/'>{translations[language]["home"]}</Link>
                        <Link className={currentPage === "news" ? 'selected' : ''} to='/news'>{translations[language]["news"]}</Link>
                        <Link className={currentPage === "press" ? 'selected' : ''} to='/press'>{translations[language]["press"]}</Link>
                        <Link className={currentPage === "work" ? 'selected' : ''} to="/work">{translations[language]["internationalWork"]}</Link>
                        <Link className={currentPage === "accommodation" ? 'selected' : ''} to='/accommodation'>{translations[language]["accommodation"]}</Link>
                        <Link className={currentPage === "graduates" ? 'selected' : ''} to='/graduates'>{translations[language]["graduates"]}</Link>
                        <Link className={currentPage === "friendbook" ? 'selected' : ''} to='/friendbook'>{translations[language]["friendbook"]}</Link>
                        <Link className={currentPage === "archive" ? 'selected' : ''} to="/archive">{translations[language]["archive"]}</Link>
                        <Link className={currentPage === "videos" ? 'selected' : ''} to="/videos">{translations[language]["videos"]}</Link>
                        <Link className={currentPage === "contact" ? 'selected' : ''} to='/contact'>{translations[language]["contact"]}</Link>
                        <Link className={currentPage === "about" ? 'selected' : ''} to='/about'>{translations[language]["about"]}</Link>
                    </div>
                </div>
            }
        </div>
    );
};

export default Header;
